import { Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '../services/user.service';
import { catchError, map, of } from 'rxjs';

export const requirePageAccess = () => {
  return () => {
    const userService = inject(UserService);
    const router = inject(Router);
    const accessDeniedUrlTree = router.createUrlTree(['/access-denied']);

    return userService.getUserInfo().pipe(
      map(({ mySglAccountEnabled }) => (mySglAccountEnabled ? true : accessDeniedUrlTree)),
      catchError(() => of(accessDeniedUrlTree))
    );
  };
};
